import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSecureFileUrl } from "@tellescope/tanstack-query";

export const useFileDownloadPage = () => {
  const { t } = useTranslation("files");
  const { secureName } = useParams<{ secureName: string }>();
  const [downloadStarted, setDownloadStarted] = useState(false);

  const downloadURL = useSecureFileUrl(secureName);

  useEffect(() => {
    if (!downloadURL || downloadStarted) return;
    window.location.href = downloadURL;
    setDownloadStarted(true);
  }, [downloadURL, downloadStarted]);

  return { downloadStarted, t };
};
